import type { CursorPage, MutationResult } from '../../api/contract';
import { createRepositoryToken } from '../../data/RepositoryProvider';
import type {
  DeliveryAttempt,
  CreateWithdrawalResolutionInput,
  WithdrawalCursorQuery,
  WithdrawalApprovalSummary,
  WithdrawalDetail,
  WithdrawalEvent,
  WithdrawalListQuery,
  WithdrawalResolutionInput,
  WithdrawalResolutionPreview,
  WithdrawalRetryInput,
  WithdrawalSummary,
} from './types';

export interface WithdrawalRepository {
  list(query: WithdrawalListQuery, signal: AbortSignal): Promise<CursorPage<WithdrawalSummary>>;
  get(withdrawalId: string, signal: AbortSignal): Promise<WithdrawalDetail>;
  listEvents(
    withdrawalId: string,
    query: WithdrawalCursorQuery,
    signal: AbortSignal,
  ): Promise<CursorPage<WithdrawalEvent>>;
  listDeliveryAttempts(
    withdrawalId: string,
    query: WithdrawalCursorQuery,
    signal: AbortSignal,
  ): Promise<CursorPage<DeliveryAttempt>>;
  retry(
    withdrawalId: string,
    input: WithdrawalRetryInput,
    idempotencyKey: string,
  ): Promise<MutationResult<WithdrawalDetail>>;
  previewResolution(
    withdrawalId: string,
    input: WithdrawalResolutionInput,
  ): Promise<WithdrawalResolutionPreview>;
  createResolution(
    withdrawalId: string,
    input: CreateWithdrawalResolutionInput,
    idempotencyKey: string,
  ): Promise<MutationResult<WithdrawalApprovalSummary>>;
}

export const withdrawalsRepositoryToken =
  createRepositoryToken<WithdrawalRepository>('withdrawals');

export const defaultWithdrawalListQuery = Object.freeze<WithdrawalListQuery>({
  cursor: '',
  pageSize: 25,
  sort: 'createdAt',
  filters: {
    partnerId: '',
    agentId: '',
    walletId: '',
    memberId: '',
    username: '',
    partnerUserId: '',
    partnerWithdrawalId: '',
    transferId: '',
    partnerCreditId: '',
    currency: '',
    status: '',
    failureCode: '',
    deliveryResult: '',
    minimumAmount: '',
    maximumAmount: '',
    createdFrom: '',
    createdTo: '',
    completedFrom: '',
    completedTo: '',
  },
});

export const defaultWithdrawalCursorQuery = Object.freeze<WithdrawalCursorQuery>({
  cursor: '',
  pageSize: 25,
});
